import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { base_url } from "../../../../config";

const OpenEmail = ({
  showModal,
  setShowModal,
  email,
  setEmail,
  handleBookTable,
  userName,
  setUserName,
}) => {

  const accessToken = localStorage.getItem("@user");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        email: email,
        first_name: userName,
      };

      const response = await axios.put(
        `${base_url}/profile-members/update`,
        payload,
        {
          params: { access_token: accessToken },
          headers: { "Content-Type": "application/json" },
        }
      );

      toast.success("Profile updated successfully!", {
        position: "top-center",
      });

      localStorage.setItem("email", email);
      localStorage.setItem("@userName", userName);
      handleBookTable();
      setShowModal(false);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong. Try again!", {
        position: "top-center",
      });
      window.location.reload();
    }
  };

  return (
    <div>
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] p-5 sm:p-0"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white w-96 p-6 rounded-2xl items-center justify-between shadow-lg"
          >
            <div
              className="text-gray-600 text-center rounded-xl w-2 absolute right-5 cursor-pointer"
              onClick={() => setShowModal(false)}
            >
              X
            </div>
            <h2 className="text-xl font-bold mb-4 text-center text-black">
              Oops! Email MIA{" "}
              <div className="text-sm text-gray-600">(Missing in Action)!</div>
            </h2>

            <div className="text-gray-700 text-center text-xs mb-5">
              Before we send your payment on its merry way, let’s make sure we
              know who to send those shiny receipts and updates. Pop in your
              deets, and we’ll take it from there!
            </div>
            <form onSubmit={handleSubmit} className="space-y-4 mt-2">
              <input
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your name"
                required
                className="border h-12 text-black border-gray-300 rounded-2xl p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="border h-12 text-black border-gray-300 rounded-2xl p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <button
                type="submit"
                className="bg-[#f3c469] hover:bg-black w-full mx-auto text-white font-bold py-2 px-4 rounded-lg"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OpenEmail;
